import styled from "@emotion/styled";

import { BaseEntityLink } from "shared/components/common/base-entity-link";
import { theme } from "shared/lib/styles";

export const StyledBaseEntityLink = styled(BaseEntityLink)`
  svg {
    inline-size: auto;
    block-size: 33px;
    ${theme.breakpoints.up("mediumDesktop")} {
      block-size: 38px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  gap: 12px;
  align-items: start;
`;
